export const getOptionText = (
  option: string | google.maps.places.AutocompleteSuggestion,
): string =>
  typeof option === 'string'
    ? option
    : (option.placePrediction?.text?.text ?? '');
